import { render, staticRenderFns } from "./DocumentTitleUpdater.vue?vue&type=template&id=02713e7e&"
import script from "./DocumentTitleUpdater.vue?vue&type=script&lang=js&"
export * from "./DocumentTitleUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports